import { useEffect, useState } from 'react';
import { Chip, Paper, TextField, Autocomplete, useTheme } from '@mui/material';
import { isString } from 'lodash';
import toastError from '../../toasts/toastError';
import api from '../../services/api';
import { getStyled } from './styles';

export function TagsContainer({ contact }) {
  const theme = useTheme();
  const classes = getStyled(theme);

  const [tags, setTags] = useState([]);
  const [selecteds, setSelecteds] = useState([]);

  const loadTags = async () => {
    try {
      const { data } = await api.get(`/tags/list`);
      setTags(data);
    } catch (err) {
      toastError(err);
    }
  };

  useEffect(() => {
    const loadTags = async () => {
      try {
        const { data } = await api.get(`/tags/list`);
        setTags(data);
      } catch (err) {
        toastError(err);
      }
    };

    loadTags();
  }, []);

  useEffect(() => {
    const selectIds = async () => {
      if (Array.isArray(contact.tags)) {
        setSelecteds(contact.tags);
      } else {
        setSelecteds([]);
      }
    };

    selectIds();
  }, [contact]);

  const createTag = async (data) => {
    try {
      const { data: responseData } = await api.post(`/tags`, data);
      return responseData;
    } catch (err) {
      toastError(err);
    }
  };

  const syncTags = async (data) => {
    try {
      const { data: responseData } = await api.post(`/tags/sync`, data);
      return responseData;
    } catch (err) {
      toastError(err);
    }
  };

  const onChange = async (value, reason) => {
    let updated = [];

    if (reason === 'create-option') {
      for (let item of value) {
        if (isString(item)) {
          if (item.trim().length < 3) {
            toastError('Tag muito curta!');
            return;
          }
          const newTag = await createTag({
            name: item,
            kanban: 0,
            color: getRandomHexColor(),
          });
          if (newTag) updated.push(newTag);
        } else {
          updated.push(item);
        }
      }
      await loadTags();
    } else {
      updated = value;
    }

    setSelecteds(updated);
    await syncTags({ contactId: contact.id, tags: updated });
  };

  function getRandomHexColor() {
    const red = Math.floor(Math.random() * 256);
    const green = Math.floor(Math.random() * 256);
    const blue = Math.floor(Math.random() * 256);
    return `#${red.toString(16).padStart(2, '0')}${green
      .toString(16)
      .padStart(2, '0')}${blue.toString(16).padStart(2, '0')}`;
  }

  return (
    <Paper>
      <Autocomplete
        multiple
        size='small'
        options={tags}
        value={selecteds}
        freeSolo
        onChange={(e, v, r) => onChange(v, r)}
        getOptionLabel={(option) => (isString(option) ? option : option.name)}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => {
            const { key, ...tagProps } = getTagProps({ index });

            return (
              <Chip
                key={key}
                variant='outlined'
                style={{
                  backgroundColor: option.color || '#eee',
                  ...classes.chip,
                }}
                label={isString(option) ? option : option.name}
                {...tagProps}
                size='small'
              />
            );
          })
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant='outlined'
            placeholder='Tags'
            sx={theme.custom.textField}
          />
        )}
        ListboxProps={{
          sx: {
            maxHeight: '300px',
            overflow: 'auto',
            '&::-webkit-scrollbar': {
              width: '6px',
            },
            '&::-webkit-scrollbar-thumb': {
              boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.3)',
              backgroundColor:
                theme.palette.mode === 'light' ? '#192734' : '#fff',
              borderRadius: '4px',
            },
            '&::-webkit-scrollbar-track': {
              backgroundColor: '#999999',
            },
          },
        }}
        PaperComponent={({ children }) => (
          <Paper
            sx={{
              width: 400,
              marginLeft: '6px',
              backgroundColor: theme.custom.colors.defaultBackground,
              '& .MuiAutocomplete-listbox': {
                color: theme.custom.colors.text,
              },
            }}
          >
            {children}
          </Paper>
        )}
      />
    </Paper>
  );
}
